import { GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_ERROR, RESET_List_USER } from "../actions/user"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const getUser = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_REQUEST:
            return {
                ...state,
                loading: true
            }

        case GET_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case RESET_List_USER:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        case GET_USER_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }

        default:
            return state;
    }
}

export default getUser